<template>
  <div class="home" v-if="!isLoading">
    <sign-modal
      :application="form.application"
      :cert-list-box-id="certListBoxId"
      :modal-id="signModalId"
      :sign-and-approve-command="signAndApproval"
      :organization="form.organization"
      :signer="this.signers[this.form.application.id]"
      @show="onShowModal"
      ref="modal"
    />
    <vue-headful :title="pageTitle"/>
    <offer-modal :text-offer="textOffer"/>
    <application-status-info-block
      v-if="isView || isEdit"
      :application="form.application"
      :application-status="applicationStatus"
      :get-signer="getSigner"
      :approval-command="approvalCommand"
      :can-view-there-buttons="canViewThisButtons"
      :actions="actions">
      <template v-slot:prevItems>
        <li v-if="canPrint(form.application)"
            v-html="applicationPdfMenuHTML">
        </li>

        <li v-if="Number(configuration.can_attach_scancopy) === 1 && Number(form.application.user_id) === Number(user.id) && form.application.status === 'awaiting_signing'">
          <a :href="url(`site/index?view=${form.application.id}#scan-copy-block`)">
            <img class="menu-item-img" :src="baseUrl + '/img/icons/statuses/scan.svg'" width="20px" height="22px" alt="" />
            Приложить скан-копию
          </a>
        </li>
      </template>

      <template v-slot:lastItems>
        <li v-if="canDuplicate(form.application)">
          <a :href="url(`site/index?duplicate_id=${form.application.id}#new`)">
            <img class="menu-item-img" :src="baseUrl + '/img/icons/statuses/copy.svg'" width="20px" height="22px" alt="" />
            Дублировать
          </a>
        </li>

        <li v-if="canDelete(form.application)">
          <a href="#" @click="deleteApplication(form.application)"
             class="text-red">
            <img class="menu-item-img" :src="baseUrl + '/img/icons/statuses/delete.svg'" width="20px" height="22px" alt="" />
            Удалить
          </a>
        </li>
      </template>
    </application-status-info-block>
    <form-section
      id="organization-section"
      title="Заявитель"
      :hasErrors="hasSectionErrors(errors, 'organization')"
    >
      <applicant-info-block v-if="canSeeUsersInLogs() && isView" :applicant="form.applicant"/>
      <organization-form-block
        v-model="form.organization"
        :application-purposes="formBlockPurposes"
        :cfg-form-fields="cfgFormFields"
        :form="form"
        :errors="errors"
        :nationalities-list="personalNationalities"
        :organization-subjects-residency="organizationSubjectsResidency"
        :organization-subjects="organizationSubjects"
        :organization-disabled="organizationDisabled"
        :timezone="timezone"
        :terminal-organizations="terminalOrganizations"
        @change-organization="setOrganization"
        @change-contract-organization="setContractOrganization"
        @disable-submit-button="handleDisableSubmitButton"
        @enable-submit-button="handleEnableSubmitButton"
      />
    </form-section>
    <form-section
      id="pass-section"
      title="Пропуск"
      :hasErrors="hasSectionErrors(errors, 'application')"
    >
      <template v-slot:step-icon>
        <step-two-icon/>
      </template>
      <pass-form-block
        v-model="form.application"
        :agent-organizations="agentOrganizations"
        :application-purposes="formBlockPurposes"
        :applicationDocuments="calculatedApplicationDocuments"
        :application-custom-fields="applicationCustomFields"
        :cfg-form-fields="cfgFormFields"
        :errors="errors"
        :form="form"
        :pass-accesses="passAccesses"
        :payment-types="paymentTypes"
        :purpose-subdivisions="purposeSubdivisions"
        :terminals="terminals"
        :terminal-regions="calculatedTerminalRegions"
        :terminal-region-sectors="terminalRegionSectors"
        :terminal-subdivisions="terminalSubdivisions"
        :terminal-tariff-periods="terminalTariffPeriods"
        :terminalTariffTimeTypes="terminalTariffTimeTypes"
        :timezone="timezone"
        :vessel-berth-book="vesselBerthBook"
        :visitor-categories="visitorCategories"
        :visitor-category-purposes="visitorCategoryPurposes"
        :personal-nationalities="personalNationalities"
        :pass-kinds="passKinds"
        :vessel-accesses="vesselAccesses"
        @disable-submit-button="handleDisableSubmitButton"
        @enable-submit-button="handleEnableSubmitButton"
        @change-date="changeDate"
        @handle-terminal-region="handleTerminalRegion"
      />
    </form-section>
    <form-section
      v-if="isPassKindMaterial"
      id="tangibles-section"
      title="Материальные ценности"
    >
      <template v-slot:step-icon>
        <step-three-icon/>
      </template>
      <tangibles-form-block
        :tangibles="form.application.tangibles"
        :form="form"
        :errors="errors"
        :application="form.application"
      >
      </tangibles-form-block>
    </form-section>
    <form-section
      id="visitors-section"
      :title="getVisitorsSectionTitle"
      class="visitors"
      :hasErrors="hasSectionErrors(errors, 'visitors')"
    >
      <template v-slot:step-icon>
        <step-three-icon
          v-if="!isPassKindMaterial"
        />
        <step-four-icon
          v-if="isPassKindMaterial"
        />
      </template>
      <template v-slot:section-header>
        <import-file-form-block
          v-if="showImportFileFormBlock"
          :excel-example="excelExample"
          :form="form"
          :terminalRegions="terminalRegions"
          @fill-visitors="fillVisitors($event, true)"
        >
          <template v-slot:before>
            <div class="mb-4">
              <b>Максимальное количество посетителей в заявке до {{ declOfNum(configuration.form_visitors, ['человека', 'человек', 'человек']) }}</b>
            </div>
          </template>

          <template v-slot:additional-text>
            <div>
              <b>(учитывая ограничение в {{ declOfNum(configuration.form_visitors, ['посетителя', 'посетителя', 'посетителей']) }} в заявке)</b>
            </div>
          </template>
        </import-file-form-block>
        <import-transport-file-form-block
          v-if="isPassKindTransport"
          :excel-example="excelExample"
          :terminalRegions="terminalRegions"
          @fill-transports="fillTransports($event, true)"
        />
      </template>
      <visitors-form-block
        v-model="form.visitors"
        :key="visitorsFormBlockKey"
        :form="form"
        :cfg-form-fields="cfgFormFields"
        :approve-form="approveForm"
        :can-scud="canScud"
        :errors="errors"
        :application-purposes="formBlockPurposes"
        :nationalities-list="personalNationalities"
        :organization-subjects="organizationSubjects"
        :organization-subjects-residency="organizationSubjectsResidency"
        :personal-nationalities="personalNationalities"
        :personal-identifications="personalIdentifications"
        :nationality-documents="nationalityDocuments"
        :terminal-regions="terminalRegions"
        :terminal-subdivisions="terminalSubdivisions"
        :transport-types="transportTypes"
        :transport-colors="transportColors"
        :transport-documents="transportDocuments"
        :typeaheads="typeaheads"
        :purpose-subdivisions="purposeSubdivisions"
        :document-masks="documentMasks"
        @handle-terminal-region="handleTerminalRegion"
        @disable-submit-button="handleDisableSubmitButton"
        @enable-submit-button="handleEnableSubmitButton"
        @change-date="changeDate"
      />
    </form-section>
    <form-section
      v-if="isEdit && this.hasPermission(permissionsEnum.editOtherApplications)"
      id="edit-application"
      title="Редактирование заявки"
    >
      <template v-slot:step-icon>
        <step-four-icon
          v-if="!isPassKindMaterial"
        />
        <step-five-icon
          v-if="isPassKindMaterial"
        />
      </template>
      <div class="text-center">
<!--    <select v-model="form.application.status" class="form-control" style="margin: auto; width: auto; margin-bottom: 10px">
          <option v-for="status in applicationStatuses"
                  :key="status.id"
                  :value="status.id">
            {{ status.name }}
          </option>
        </select>-->
        <button
            type="button"
            class="btn btn-default btn-primary-white"
            style="min-width: 149px"
            :disabled="formSending"
            @click="editApplication"
        >
          Сохранить
        </button>
      </div>
    </form-section>
<!--    <form-section
      v-if="isView && form.application.time_type !== 'one' && form.application.status !== 'awaiting_signing' && form.application.status && Number(form.application.has_user_sign) !== 1"
      id="scan-copy"
      title="Дополнительная информация"
    >
      <template v-slot:step-icon>
        {{ '' }}
      </template>
      <scan-copy-form-block
        v-if="isView && form.application.time_type !== 'one' && form.application.status !== 'awaiting_signing'"
        :form="form"
        :approve-form="approveForm"
      />
    </form-section>-->
    <form-section
      v-if="(!isView && !isEdit) || isView && form.application.status === 'awaiting_signing'"
      id="apply-section"
      title="Подача заявки"
    >
      <template v-slot:step-icon>
        <step-four-icon
          v-if="!isPassKindMaterial"
        />
        <step-five-icon
          v-if="isPassKindMaterial"
        />
      </template>
      <div v-show="showSignerAuthority" class="row">
        <div class="col-md-4">
          <organization-manager-authority-input
            v-model="form.organization.authority_of_manager"
            :form="form"
            :errors="errors"
            :organization-subdivisions-exists="organizationSubdivisionsExists"
            :disabled="disabledAuthorityOfManager"
            @change="changeManagerAuthority"
          />
        </div>
        <div v-if="!isSupervisorSubdivision" class="col-md-4">
          <organization-manager-position-input
            v-model="form.organization.position_of_manager"
            :form="form"
            :errors="errors"
            :prevValue="prevManagerPosition"
            :disabled="disabledPositionOfManager"
          />
        </div>
        <div v-if="form.organization.authority_of_manager === 'without-authority'" class="col-md-4">
          <organization-manager-name-input
            v-model="form.organization.director_name"
            :form="form"
            :errors="errors"
            :prevValue="prevManagerName"
            :disabled="disabledDirectorName"
          />
        </div>
        <div v-if="isSupervisorSubdivision" class="col-md-8">
          <organization-subdivision-input
            v-model="form.application.organization_subdivision_id"
            :form="form"
            :errors="errors"
            :items="organizationSubdivisions"
            :disabled="disabledOrganizationSubdivision"
          />
        </div>
        <div v-if="form.organization.authority_of_manager === 'with-authority'" class="col-md-4" style="padding-top: 30px">
          <select
            class="form-control"
            v-model="form.application.power_of_attorney_id"
            @change="handlePowerOfAttorneyChange"
          >
            <option :value="null">Выберите доверенность...</option>
            <option
              v-for="poa in filteredPowersOfAttorney"
              :key="poa.id"
              :value="poa.id"
            >
              {{ poa.fio || '' }}
            </option>
            <option value="add-new" class="text-primary font-weight-bold">Добавить новую доверенность</option>
          </select>
          <error-help-block class="has-error" :current-error="hasError(this.errors.application, 'power_of_attorney_id') ? 'Необходимо выбрать доверенность' : ''"/>
          <div v-if="form.application.power_of_attorney_id && !directorNameMatchesPowerOfAttorney" class="alert alert-warning mt-10">
            ФИО подписанта в заявке не совпадает с ФИО в выбранной доверенности.
          </div>
          <div v-if="form.application.power_of_attorney_id && !innMatchesPowerOfAttorney" class="alert alert-warning mt-10">
            ИНН организации не совпадает с ИНН в выбранной доверенности.
          </div>
        </div>

        <power-of-attorney-modal
          @save="handlePowerOfAttorneySave"
        />
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="row" v-if="isSigning && form.organization.authority_of_manager !== 'supervisor-subdivision'">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <p style="margin: 0 0 10px">
              Для подачи заявки подпишите её квалифицированной электронной подписью (подойдет подпись,
              которой подписываются документы организации при сдаче налоговой отчетности в электронном
              виде или для работы на электронных торговых площадках). Для этого нажмите на кнопку
              «Подписать ЭЦП и подать».
            </p>
            <p v-if="form.application.status === 'awaiting_signing'" style="margin: 0 0 10px">
              В качестве альтернативы загрузите ниже скан-копию распечатанной заявки, заверенной подписью руководителя и
              печатью организации. Затем нажмите на кнопку «Подать без ЭЦП».
            </p>
            <p style="margin: 0 0 10px" v-else>
              В качестве альтернативы нажмите на кнопку «Сформировать заявку», после чего заявку нужно
              будет распечатать, заверить подписью руководителя и печатью организации, отсканировать и
              загрузить скан-копию в сервис.
            </p>
          </div>
        </div>
        <scan-copy-form-block
          v-if="Number(configuration.can_attach_scancopy) === 1 && isView && form.application.status === 'awaiting_signing'"
          v-model="hasUploadedScanCopy"
          :form="form"
          ref="scanCopy"
          :approve-form="approveForm"
        />
        <div class="offer-text" style="margin-top: 5px; display: flex; flex-direction: column">
          <div style="display:flex; flex-direction: row">
            <label class="flex-label" style="color:#333;">
              <input type="checkbox" :class="this.agreementErrorMessage ? 'invalid-checkbox': ''"
                     id="agreement"
                     v-model="agreement"
                     @click="clearErrorMessage()"
              />
              Даю согласие на&nbsp;обработку персональных данных и&nbsp;принимаю
            </label>
            <a v-b-modal.modal-offer>условия предоставления услуги.</a>
          </div>
          <div class="has-error" style="margin-left: 20px; margin-top: -10px" v-if="this.agreementErrorMessage">
            Подтвердите согласие на обработку персональных данных!
          </div>
        </div>
        <div class="row text-center form-send-button-block">
          <div class="col-md-3 col-sm-12 col-xs-12"
               v-if="showSignAndApply && territorySelected">
          <button
              type="button"
              class="btn btn-success btn-primary-white"
              :disabled="isDisabledSubmitButton || hasUploadedScanCopy"
              @click="signAndApply"
              style="width: 100%"
            >Подписать ЭЦП и подать
            </button>
          </div>
          <div class="col-md-3 col-sm-12 col-xs-12"
               v-if="isSigning && territorySelected"
          >
            <button
              type="button"
              :class="'btn btn-primary-white ' + applyButtonClasses"
              :disabled="isDisabledSubmitButton"
              @click="applyApplication"
              style="width: 100%"
            >{{ applyButtonText }}
            </button>
          </div>
          <div class="col-md-3 col-sm-12 col-xs-12"
               v-if="!isSigning && !isScanCopy && territorySelected">
            <button
              type="button"
              class="btn btn-success btn-primary-white"
              :disabled="isDisabledSubmitButton"
              @click="applyApplication"
              style="width: 100%"
            >
              Подать заявку
            </button>
          </div>
          <div class="col-md-3 col-sm-12 col-xs-12" v-if="!isView">
            <button
              type="button"
              class="btn btn-default btn-primary-white"
              :disabled="formSending"
              @click="applyDraftApplication"
              style="width: 100%"
            >
              Сохранить черновик
            </button>
          </div>
          <div
            v-if="Number(configuration.can_attach_scancopy) === 1 && isView && form.application.status === 'awaiting_signing'"
            class="col-md-3 col-sm-12 col-xs-12"
          >
            <button
              type="button"
              class="btn btn-primary"
              :disabled="hasUploadedScanCopy === false"
              style="width: 100%"
              @click="approveApplication"
            >Подать без ЭЦП
            </button>
          </div>
        </div>
        <pass-errors-block
          :form="form"
          :errors="errors"
          :disabled-submit-button="disabledSubmitButton"
          :mark-model-error="markModelError"
        />
      </div>
    </form-section>
    <form-section
      v-else-if="isView"
      id="approve-application"
      title="Согласование заявки"
    >
      <div v-show="showSignerAuthority" class="row">
        <div class="col-md-4">
          <organization-manager-authority-input
            v-model="form.organization.authority_of_manager"
            :form="form"
            :errors="errors"
            :organization-subdivisions-exists="organizationSubdivisionsExists"
            :disabled="disabledAuthorityOfManager"
            @change="changeManagerAuthority"
          />
        </div>
        <div v-if="!isSupervisorSubdivision" class="col-md-4">
          <organization-manager-position-input
            v-model="form.organization.position_of_manager"
            :form="form"
            :errors="errors"
            :prevValue="prevManagerPosition"
            :disabled="disabledPositionOfManager"
          />
        </div>
        <div v-if="form.organization.authority_of_manager === 'without-authority'" class="col-md-4">
          <organization-manager-name-input
            v-model="form.organization.director_name"
            :form="form"
            :errors="errors"
            :prevValue="prevManagerName"
            :disabled="disabledDirectorName"
          />
        </div>
        <div v-if="form.organization.authority_of_manager === 'with-authority'" class="col-md-4">
          <div class="form-group">
            <label for="form-power-of-attorney-fio" class="control-label">Доверенность</label>
            <input
              type="text"
              class="form-control"
              id="form-power-of-attorney-fio"
              :value="selectedPowerOfAttorneyData ? selectedPowerOfAttorneyData.fio : ''"
              disabled
            />
          </div>
        </div>
        <div v-if="isSupervisorSubdivision" class="col-md-8">
          <organization-subdivision-input
            v-model="form.application.organization_subdivision_id"
            :form="form"
            :errors="errors"
            :items="organizationSubdivisions"
            :disabled="disabledOrganizationSubdivision"
          />
        </div>
      </div>
      <template v-slot:step-icon>
        <step-four-icon
          v-if="!isPassKindMaterial"
        />
        <step-five-icon
          v-if="isPassKindMaterial"
        />
      </template>
      <div v-if="selectedPowerOfAttorneyData && form.application.power_of_attorney_id" class="row mb-4">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header bg-light d-flex justify-content-between align-items-center">
              <h5 class="mb-0">Доверенность:</h5>
              <div>
                <button v-if="selectedPowerOfAttorneyData.mchd_url" @click="downloadMchd" class="btn btn-sm btn-outline-primary mr-2">
                  <i class="fa fa-file-text-o"></i> МЧД
                </button>
                <button v-if="selectedPowerOfAttorneyData.signature_url" @click="downloadSignature" class="btn btn-sm btn-outline-secondary">
                  <i class="fa fa-file"></i> Подпись
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <approve-application-form-block
        :form="form"
        :terminal-regions="terminalRegions"
        :approve-form="approveForm"
        :status-actions="actions"
        :errors="errors"
        :get-signer="getSigner"
        :approval-command="approvalCommand"
      >
        <template v-slot:before>
          <scan-copy-form-block
            v-if="showScanCopyBlock"
            :form="form"
            :approve-form="approveForm"
          />
        </template>
      </approve-application-form-block>
    </form-section>
  </div>
</template>

<script>
import Home from '../common/views/Home'
import UppyUploader from '@/common/components/inputs/UppyUploader.vue'
import PowerOfAttorneyModal from '@/common/components/PowerOfAttorneyModal.vue'
import ErrorHelpBlock from '@/common/components/application/ErrorHelpBlock.vue'

export default {
  components: { ErrorHelpBlock, PowerOfAttorneyModal, UppyUploader },
  extends: Home,
  methods: {
    declOfNum(number, titles, showNumber = true) { // TODO вынести в какой-то миксин\глобальные функции
      const cases = [2, 0, 1, 1, 1, 2]

      return (showNumber ? number + ' ' : '') + titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]]
    }
  }
}
</script>
